import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupInviteContentProps } from './msg-group-invite-content';
import { MsgGroupInviteContent } from './msg-group-invite-content';

export interface MsgGroupInvitePreviewProps extends MsgGroupInviteContentProps {}

export const MsgGroupInvitePreview = memo(function MsgGroupInvitePreview({
  message,
}: MsgGroupInvitePreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupInviteContent message={message} />
    </LastMessageSystem>
  );
});
